import actionTypes from '../../actions/actionTypes';

const _initState = { 
  isLoading: false, 
  data: [], 
  total: 0 
};

const headerListOdberatel = (state = _initState, action) => {
  switch (action.type) {
	case actionTypes.GET_LIST_ODBERATEL_HEADER_REQUEST:
	  return { ...state, isLoading: true };

	case actionTypes.GET_LIST_ODBERATEL_HEADER_SUCCESS:
	  return { isLoading: false, data: action.res.Data.Items, total: action.res.Data.TotalRecords };

	case actionTypes.GET_LIST_ODBERATEL_HEADER_FAILURE:
	  return _initState;
  
	default:
	  return state
  }
};

export default headerListOdberatel;